<script>
import CashboxManual from '@/views/ClinicPanel/CashboxManual.vue';
import CashboxOnlineCheck from '@/views/ClinicPanel/CashboxOnlineCheck.vue';
import notifierMixin from '@/mixins/notifierMixin';

/**
 * @description Раздел кассы провайдера "Онлайн-чеки" или ручной кассы.
 */
export default {
  created() {
    this.fetchCashboxList();
  },
  computed: {
    isSelectedOnlineCheck() {
      if (!this.selectedCashbox) {
        return false;
      }
      return this.selectedCashbox.tags.includes('online-check');
    },
  },
  data() {
    return {
      selectedCashbox: null,
      cashboxList: [],
    };
  },
  methods: {
    preselectCashbox() {
      const { initialCashboxId } = this.$route.params;
      if (initialCashboxId) {
        const initialCashbox = this.cashboxList.find(
          ({ id }) => id === initialCashboxId,
        );
        if (initialCashbox) {
          return initialCashbox;
        }
      }
      const defaultCashbox = this.cashboxList.find(
        ({ tags }) => tags.includes('default'),
      );
      if (defaultCashbox) {
        return defaultCashbox;
      }
      return this.cashboxList[0] || null;
    },
    fetchCashboxList() {
      const onSuccess = (list) => {
        this.cashboxList = list;
        this.selectedCashbox = this.preselectCashbox();
      };
      this
        .$cashboxGateway
        .viewList()
        .then((result) => result.fold(this.notifyFail, onSuccess));
    },
    onInputCashbox(cashboxId) {
      const cashbox = this.cashboxList.find(({ id }) => cashboxId === id);
      this.selectedCashbox = cashbox;
    },
  },
  mixins: [notifierMixin],
  name: 'ClinicPanelCashboxOnlineCheckOrManual',
  render(createElement) {
    if (!this.selectedCashbox) { return createElement(); }
    const data = {
      key: this.selectedCashbox.id,
      on: { 'input-cashbox': this.onInputCashbox },
      props: {
        cashboxList: this.cashboxList,
        selectedCashboxId: this.selectedCashbox.id,
      },
    };
    if (this.isSelectedOnlineCheck) {
      return createElement(CashboxOnlineCheck, data);
    }
    return createElement(CashboxManual, data);
  },
};
</script>
